import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { HubFeature } from '@ats/api/cm';

const pathStart = 'Users|Search|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

type LocNameStart = 'SPUserSearch';
export type SPUserSearchLocNames =
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}LabelLogin`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelEmail`
	| `${LocNameStart}LabelDisabled`
	| `${LocNameStart}LabelAdmin`
	| `${LocNameStart}LabelInternal`;

export const spUserSearchLocs: LocDefs<SPUserSearchLocNames> = {
	SPUserSearchTitlePage: {
		defaultValue: 'User List',
		description: 'Page Title',
		displayPath: `${pathStart}Page Title`,
		displayType: 'Title',
		legacyName: 'Core/Users.List.Title.PageTitle',
		...sharedProperties,
	},
	SPUserSearchLabelLogin: {
		defaultValue: 'Login',
		description: 'Column heading for: Login.',
		displayPath: `${pathStart}Login`,
		displayType: 'Label',
		legacyName: 'Core/Users.List.ColumnHeading.Login',
		...sharedProperties,
	},
	SPUserSearchLabelName: {
		defaultValue: 'Name',
		description: 'Column heading for: Name.',
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		legacyName: 'Core/Users.List.ColumnHeading.Name',
		...sharedProperties,
	},
	SPUserSearchLabelEmail: {
		defaultValue: 'Email',
		description: 'Column heading for: Email.',
		displayPath: `${pathStart}Email`,
		displayType: 'Label',
		legacyName: 'Core/Users.List.ColumnHeading.Email',
		...sharedProperties,
	},
	SPUserSearchLabelDisabled: {
		defaultValue: 'Disabled',
		description: 'Column heading for: Disabled.',
		displayPath: `${pathStart}Disabled`,
		displayType: 'Label',
		legacyName: 'Core/Users.List.ColumnHeading.Disabled',
		...sharedProperties,
	},
	SPUserSearchLabelAdmin: {
		defaultValue: 'Admin',
		description: 'Column heading for: Admin.',
		displayPath: `${pathStart}Admin`,
		displayType: 'Label',
		legacyName: 'Core/Users.List.ColumnHeading.Admin',
		...sharedProperties,
	},
	SPUserSearchLabelInternal: {
		defaultValue: 'Internal',
		description: 'Column heading for: Internal.',
		displayPath: `${pathStart}Internal`,
		displayType: 'Label',
		legacyName: 'Core/Users.List.ColumnHeading.Internal',
		...sharedProperties,
	},
};

export type SPUserSearchLocType = LocMap<SPUserSearchLocNames>;
